import MemberRequestPage from '@/pages/MemberRequestPage/MemberRequestPage'
import { PAGE_LINKS, PAGE_STATUS } from '../pageConst'

export const statusRoutes = [
  {
    path: PAGE_STATUS,
    children: [
      {
        path: PAGE_LINKS.memberRequest,
        element: <MemberRequestPage />,
      },
    ],
  },
]
